'use client';
import { createComponent } from "../internals/utils/index.js";
export var ImageWrapper = createComponent({
  name: 'ImageWrapper',
  componentAs: 'div'
});